// v3-edison/front/src/utils/ringoverEvents.js

/**
 * Noms des custom DOM events Ringover dispatches depuis cache.js (socket V2).
 * Les composants consommateurs ecoutent via window.addEventListener.
 */
export const RINGOVER_NEW_CLIENT_CALL = 'RINGOVER_NEW_CLIENT_CALL';
export const RINGOVER_CURRENT_CONTACT_CALL = 'RINGOVER_CURRENT_CONTACT_CALL';
export const RINGOVER_NEW_CLIENT_CALL_ENDED = 'RINGOVER_NEW_CLIENT_CALL_ENDED';
